import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ equipmentParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `equipment/getsearched`,
      params: equipmentParams,
    });
    const allEquipment = data;
    yield put(Actions.setAll({ allEquipment }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllPackingDevices({ param }) {
  try {
    const { data } = yield call(api.get, {
      route: `equipment/packing/getpackingdevices?equipmentId=` + param,
    });
    const packingDeviceData = data;
    yield put(Actions.setAllPackingDevices({ packingDeviceData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllEquipments() {
  try {
    const { data } = yield call(api.get, {
      route: `equipment`,
    });
    const allEquipmentsData = data;
    yield put(Actions.setAllEquipments({ allEquipmentsData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateEquipment({ equipmentData, actionName, equipmentParams, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `equipment`,
      data: equipmentData,
    });
    if (equipmentParams) yield put(Actions.fetchAll({ equipmentParams }));
    if (callback) callback();
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.EQUIPMENT_CREATED
        : CONSTANT_VARIABLES.EQUIPMENT_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteEquipment({ id, equipmentParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `equipment/${id}`,
    });
    yield put(Actions.fetchAll({ equipmentParams }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllEquipTypes() {
  try {
    const { data } = yield call(api.get, {
      route: `equipmentTypes`,
    });
    const equipmentTypes = data;
    yield put(Actions.setAllEquipTypes({ equipmentTypes }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchEnergyConfigs() {
  try {
    const { data } = yield call(api.get, {
      route: `AssetsEnergyConfiguration/energyconfigs`,
    });
    const energyConfigs = data;
    yield put(Actions.setEnergyConfigs({ energyConfigs }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchEquipmentsByFactoryId({ factoryId }) {
  try {
    if (factoryId > 0) {
      const { data } = yield call(api.get, {
        route: `equipment/factory/${factoryId}`,
      });
      const factoryEquipments = data;
      yield put(Actions.setEquipmentsByFactoryId({ factoryEquipments }));
    }
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchStandaloneEquipmentsByFactoryId({ factoryId }) {
  try {
    if (factoryId > 0) {
      const { data } = yield call(api.get, {
        route: `equipment/factory/standalone-equipments/${factoryId}`,
      });
      const factoryEquipments = data;
      yield put(Actions.setEquipmentsByFactoryId({ factoryEquipments }));
    }
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

//fetch Unique Devices
function* fetchUniqueDevices({ deviceId }) {
  try {
    const { data } = yield call(api.get, {
      route: `equipment/IsDeviceIdAvailable/${deviceId}`,
    });
    const uniqueDeviceIdData = data;
    yield put(Actions.setUniqueDeviceIdData({ uniqueDeviceIdData }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* isJobAssigned({ equipmentId }) {
  try {
    const { data } = yield call(api.get, {
      route: `job/IsJobAssigned/equipment/${equipmentId}`,
    });
    const isJobAssigned = data;
    yield put(Actions.setIsJobAssigned({ isJobAssigned }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}
function* isPlcIdConnected({ equipmentId, plcId, callback }) {
  try {
    const { data } = yield call(api.get, {
      route: `equipment/${equipmentId}/isPlcIdConnected/${plcId}`,
    });
    const isPlcIdConnected = data ? data.toJS() : null;
    yield put(Actions.setIsPlcIdConnected({ isPlcIdConnected }));
    if (callback) {
      if (isPlcIdConnected?.isExists) {
        callback(`PLC ${plcId} already in use. It is attached to '${isPlcIdConnected.equipmentId}'`);
      } else {
        callback();
      }
    }
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllVisionEquipments({ factoryId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `equipment/GetAllVisionEquipments/${factoryId}`,
    });
    const allVisionEquipments = data;
    yield put(Actions.setAllVisionEquipments({ allVisionEquipments }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchEquipmentLinePosition({ equipmentId }) {
  try {
    const { data } = yield call(api.get, {
      route: `equipment/GetLinePosition/${equipmentId}`,
    });
    const equipmentLinePosition = data;
    yield put(Actions.setEquipmentLinePosition({ equipmentLinePosition }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL_PACKING_DEVICES, fetchAllPackingDevices),
    takeLatest(ActionTypes.FETCH_UNIQUE_DEVICE_ID, fetchUniqueDevices),
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.FETCH_ALL_EQUIPMENTS, fetchAllEquipments),
    takeLatest(ActionTypes.ADD_OR_UPDATE_EQUIPMENT, addorUpdateEquipment),
    takeLatest(ActionTypes.DELETE_EQUIPMENT, deleteEquipment),
    takeLatest(ActionTypes.FETCH_ALL_EQUIPMENT_TYPES, fetchAllEquipTypes),
    takeLatest(ActionTypes.FETCH_ENERGY_CONFIGS, fetchEnergyConfigs),
    takeLatest(ActionTypes.FETCH_EQUIPMENTS_BY_FACTORY_ID, fetchEquipmentsByFactoryId),
    takeLatest(ActionTypes.FETCH_STANDALONE_EQUIPMENTS_BY_FACTORY_ID, fetchStandaloneEquipmentsByFactoryId),
    takeLatest(ActionTypes.IS_JOB_ASSIGNED, isJobAssigned),
    takeLatest(ActionTypes.FETCH_IS_PLC_ID_CONNECTED, isPlcIdConnected),
    takeLatest(ActionTypes.FETCH_ALL_VISION_EQUIPMENTS, fetchAllVisionEquipments),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_LINE_POSITION, fetchEquipmentLinePosition),
  ]);
}
